import { app } from '../../app';

app.component('confirmDelete', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    templateUrl: require('./confirm-delete.html'),
});



// WEBPACK FOOTER //
// ./src/portal/modals/confirm-delete/confirm-delete.component.js